export default "__VITE_ASSET__be197664__"